"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonschema_1 = require("../../utils/jsonschema");
var expressions_1 = require("../../types/expressions");
var schema = {
    $id: jsonschema_1.$id('functionCallExpression'),
    title: expressions_1.ResolvedExpressionType.FunctionCall,
    type: 'object',
    properties: {
        $expression: {
            type: 'string',
            enum: [expressions_1.ResolvedExpressionType.FunctionCall]
        },
        function: {
            $ref: jsonschema_1.$id('functionExpression')
        },
        arguments: {
            $ref: jsonschema_1.$id('arrayExpression')
        }
    },
    additionalProperties: false,
    required: ['$expression', 'function']
};
exports.default = schema;
//# sourceMappingURL=functionCall.schema.js.map